// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"ecefa3d0","444":"5512fb7a","453":"0ccb7fb4","538":"8fa954ba","858":"98818533","994":"26201903"}[chunkId] + ".chunk.js";
};